import articleDeliveryStatuses from "../articles/constants/articleDeliveryStatuses";
import articleDeliveryTypes from "../articles/constants/articleDeliveryTypes";

import { canDeliverArticleToChannel } from "./utils/deliverArticlesToChannels";

export default function getArticleAutoDeliverySettings({
	article,
	channel,
	overrides = {},
	now = new Date(),
	onlyDeliveryNeeded = false,
}) {
	const metadataStatus =
		article.channels[channel.id]?.delivery?.metadata?.status || articleDeliveryStatuses.DELIVERY_NOT_STARTED;

	const artifactStatus =
		article.channels[channel.id]?.delivery?.artifact?.status || articleDeliveryStatuses.DELIVERY_NOT_STARTED;

	const metadataDeliveryNeeded = [
		articleDeliveryStatuses.DELIVERY_NEEDED,
		articleDeliveryStatuses.DELIVERY_FAILED,
	].includes(metadataStatus);

	const artifactDeliveryNeeded = [
		articleDeliveryStatuses.DELIVERY_NEEDED,
		articleDeliveryStatuses.DELIVERY_FAILED,
	].includes(artifactStatus);

	const metadataDeliveryPossible = canDeliverArticleToChannel({
		channel,
		article,
		deliveryType: articleDeliveryTypes.METADATA,
		now,
	});

	const artifactDeliveryPossible = canDeliverArticleToChannel({
		channel,
		article,
		deliveryType: articleDeliveryTypes.ARTIFACT,
		now,
	});

	const wantToDeliverMetadata =
		overrides.metadata === undefined
			? metadataDeliveryNeeded
			: !!overrides.metadata && (!onlyDeliveryNeeded || metadataDeliveryNeeded);

	const wantToDeliverArtifact =
		overrides.artifact === undefined
			? artifactDeliveryNeeded
			: !!overrides.artifact && (!onlyDeliveryNeeded || artifactDeliveryNeeded);

	const forceMetadata =
		artifactDeliveryPossible &&
		wantToDeliverArtifact &&
		(channel.disableArtifactDeliveryWithoutMetadata || channel.forceDeliveryOfMetadataAndFilesSimultaneously);

	const forceArtifact =
		metadataDeliveryPossible && wantToDeliverMetadata && channel.forceDeliveryOfMetadataAndFilesSimultaneously;

	const deliverMetadata =
		metadataDeliveryPossible &&
		(wantToDeliverMetadata || forceMetadata) &&
		(!forceArtifact || artifactDeliveryPossible);

	const deliverArtifact =
		artifactDeliveryPossible &&
		(wantToDeliverArtifact || forceArtifact) &&
		(!forceMetadata || metadataDeliveryPossible);

	return {
		metadata: !!deliverMetadata,
		artifact: !!deliverArtifact,
	};
}

export function getArticlesAutoDeliverySettings({ articles, channel, overrides, now }) {
	return articles
		.map((article) => getArticleAutoDeliverySettings({ article, channel, overrides, now }))
		.reduce(
			(acc, settings) => {
				return {
					metadata: acc.metadata || settings.metadata,
					artifact: acc.artifact || settings.artifact,
				};
			},
			{
				metadata: false,
				artifact: false,
			},
		);
}
